<template>
   <div class="container px-0 bg-danger">
      <div class="offcanvas offcanvas-end rounded-2 shadow" 
            data-bs-scroll="true" 
            data-bs-backdrop="false" 
            tabindex="-1" 
            id="offcanvasLabels" 
            aria-labelledby="offcanvasLabelsLabel"
            @blur="focusOff()"
         >
         <!--
            @blur="focusOff()"
            <div class="row p-1">
            :style="{'background-color': label.backGroundColor, 'color': label.textColor}" 
         -->
         <div class="offcanvas-header">
            <h6 id="offcanvasLabeslLabel">Etiquetas ({{cnttId}})</h6>
            <button type="button" class="btn-close btn-sm text-reset" data-bs-dismiss="offcanvas" aria-label="Close" ref="btn_out_offcanvas"></button>
         </div>
         <hr class="m-0"/>
         <!--
         <div class="offcanvas-body row gap-1">
            <div class="bg-warning lb-scroll row">
         -->
         <div class="offcanvas-body">
            <div class="lb-scroll row gap-1">
               <div v-for="(label, index) in labels" 
                     :key="index"
                     class="fp-onOff btn-info rounded"
                     :style="{'background-color': label.backGroundColor, 'color': label.textColor}"
                     :title="'(' + label.id + ')'"
                     @click="setLabelId(label.id)"
                     >
                  <div class="row">
                     <div class="col-10 text-start">
                        <b>{{label.name}}</b>
                     </div>
                     <div class="col-2">
                        <font-awesome-icon v-if="label.assigned" icon="check" />
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
//import { ref, nextTick } from 'vue';
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'

import WspService from "../workSpace.service";

export default {
   setup() {
      const store = useStore()
      const cnttId = ref(store.state.wspace.contentId)
      const btn_out_offcanvas = ref(null)
      const boardId = ref(null)
      const cardTypeId = ref(0)
      const cellId = ref(0)
      const labels = ref({})

      onMounted(() => {
         let myOffCanvas = document.getElementById('offcanvasLabels')
         myOffCanvas.addEventListener('shown.bs.offcanvas', function (event) {
         console.log(store.state.wspace.contentId)
         cnttId.value = store.state.wspace.contentId
         let button = event.relatedTarget
         cellId.value = button.getAttribute('data-cell-id')
         cardTypeId.value = button.getAttribute('data-card-type-id')
         //boardId.value = WspService.getBoardId(store)
         boardId.value = button.getAttribute('data-board-id')
         getAllLabels(boardId.value, cardTypeId.value, cnttId.value)
         myOffCanvas.focus()
         console.log(" show label's OC")
         })
         console.log("label's OC")
      })
      /*
      watchEffect(() => {
         cnttId.value = store.state.wspace.contentId
      })
      */
      function setLabelId (labelId) {
         console.log("label > id: "+labelId)
         /*
         */
         let cnttData = {}
            cnttData.labelId = labelId
            cnttData.userId = store.state.auth.user.id
         WspService.upContent(
            cnttId.value,    // contentId,
            cellId.value,    // cellId,
            boardId.value,  // boardId
            'LBL',   // code
            cnttData    // cnttData
         )
         .then(response => {
            console.log("upContent > FP > Id: "+response.data)
            //nextTick(() => {
               //getContent(response.data)
               getAllLabels(boardId.value, cardTypeId.value, response.data)
               store.dispatch("wspace/setContentId", -3)
            //})
         })
         .catch(error => {
            console.log(error);
         });
         //store.dispatch("wspace/setContentId", -3)
      }
      
      function getAllLabels(boardId, cardTypeId, contentId) {
         WspService.getAllLabels(boardId, cardTypeId, contentId)
         .then(response => {
            console.log(response.data)
            labels.value = response.data
            //console.log("content ok: "+content.value.title)
         })
         .catch(error => {
            console.log(error);
         });
      }

      function focusOff() {
         //
         let timer = 1;
         let interval = setInterval(() => {
         if (timer === 0) {
            clearInterval(interval)                
         } else {
            timer--
            console.log(timer)
            btn_out_offcanvas.value.click()
            console.log(timer)
         }             
         }, 125)
         //
         //         this.$refs.btnEdit.click(); btn-out-offcanvas
         //console.log("sali del offCanvas")
      }

      return {
         cnttId,
         setLabelId,
         focusOff,
         btn_out_offcanvas,
         cellId,
         labels,
      }
   }
}
</script>

<style scoped>
.offcanvas-end {
  top: 25px;
  right: 100px;
  width: 350px;
  height: fit-content;
}
.lb-scroll {
   max-height: calc(100vh - 150px);
   overflow: auto;
}
.btn-info {
   opacity: .8;
}
.btn-info:hover {
   /*background-color:  #cacfd2 ;*/
   opacity: 1;
}
.btn-sm {
   width: max-content;
}
.fp-onOff {
  width: 333px;
  height: 26px;
  text-align: center;
   color: white;
}
.tc-withe {
   color: white;
}
</style>